module.exports = __webpack_public_path__ + "static/img/6.595f388.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/service/imgs/6.png
// module id = UdeT
// module chunks = 1